<template>
  <div class="output-schema">
    <a-card title="出参定义" size="small">
      <pre v-if="outputParams" class="json-display">{{ formattedOutputParams }}</pre>
      <div v-else style="color: #999; text-align: center; padding: 16px">
        该Worker未配置出参定义
      </div>
    </a-card>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'OutputSchema',
  props: {
    outputParams: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const formattedOutputParams = computed(() => {
      if (!props.outputParams) return '';
      return JSON.stringify(props.outputParams, null, 2);
    });

    return {
      outputParams: computed(() => props.outputParams),
      formattedOutputParams
    };
  }
};
</script>

<style scoped>
.output-schema {
  margin-bottom: 16px;
}

.json-display {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>

